export const CREATE_CORRECTION_CONTRACT_ATTEMPT = 'CREATE_CORRECTION_CONTRACT_ATTEMPT';
export type CREATE_CORRECTION_CONTRACT_ATTEMPT = typeof CREATE_CORRECTION_CONTRACT_ATTEMPT;

export const CREATE_CORRECTION_CONTRACT_SUCCESS = 'CREATE_CORRECTION_CONTRACT_SUCCESS';
export type CREATE_CORRECTION_CONTRACT_SUCCESS = typeof CREATE_CORRECTION_CONTRACT_SUCCESS;

export const CREATE_CORRECTION_CONTRACT_FAILURE = 'CREATE_CORRECTION_CONTRACT_FAILURE';
export type CREATE_CORRECTION_CONTRACT_FAILURE = typeof CREATE_CORRECTION_CONTRACT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/contract-corrections/create/Types.tsx